"use client";

import { HowToGifClient } from "@/components/marketing/HowToGifClient";
import { useI18n } from "@/components/providers/I18nProvider";
import type { GettingAroundId } from "@/lib/onboarding/gettingAroundCatalog";

/** Locale-safe wrapper shared by marketing pages and the in-app walkthrough. */
export function HowToGif({
  entryId,
  className,
  priority = false,
}: {
  entryId: GettingAroundId;
  className?: string;
  priority?: boolean;
}) {
  const { locale } = useI18n();
  return (
    <HowToGifClient
      entryId={entryId}
      className={className}
      priority={priority}
      locale={locale}
    />
  );
}
